import { ViewChild, Component } from '@angular/core';
import { NavController, NavParams, MenuController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';

import { BusinessQrcodeScannerPage } from '../business-qrcode-scanner/business-qrcode-scanner';
import { BusinessDetailPage } from '../business-detail/business-detail';
import { BusinessPunchCardListPage } from '../business-punch-card-list/business-punch-card-list';
import { BusinessOfferListPage } from '../business-offer-list/business-offer-list';
import { BusinessSpecialtyListPage } from '../business-specialty-list/business-specialty-list';
import { BusinessUserListPage } from '../business-user-list/business-user-list';
import { BusinessMessagingMainPage } from '../business-messaging-main/business-messaging-main';
import { BusinessDashboardPage } from '../business-dashboard/business-dashboard';
import { BusinessInvoiceMainPage } from '../business-invoice-main/business-invoice-main';
import { BusinessProductListPage } from '../business-product-list/business-product-list';
import { BusinessProductPaymentManagerPage } from '../business-product-payment-manager/business-product-payment-manager';
import { BusinessProductPaymentMainPage } from '../business-product-payment-main/business-product-payment-main';
import { BusinessProductCategoryListPage } from '../business-product-category-list/business-product-category-list';
import { BusinessModifierGroupListPage } from '../business-modifier-group-list/business-modifier-group-list';

import { BusinessPunchCardMainPage } from '../business-punch-card-main/business-punch-card-main';

import { PushNotificationHandlerProvider } from '../../providers/push-notification-handler';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-main',
  templateUrl: 'business-main.html',
})
export class BusinessMainPage {
  rootPage: any;

  constructor(    
    public pushNotificationHandlerProvider: PushNotificationHandlerProvider,
    public menuCtrl: MenuController,
    public globals: Globals,
    public statusBar: StatusBar, 
    public navCtrl: NavController, 
    public navParams: NavParams) {
    this.rootPage = BusinessProductPaymentMainPage;

    //Try registering to oneSignal as business user
    //TODO: Register business for next release
    if(this.globals.registeredAsBusiness){

      this.globals.registeredAsBusiness = false;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessMainPage');
  }

  openPage(pageName){
    switch (pageName) {
      case "dashBoard":
        this.rootPage = BusinessDashboardPage
        break;      
      case "punchCard":
        this.rootPage = BusinessPunchCardMainPage;
        break;
      case "offers":
        this.rootPage = BusinessOfferListPage;
        break;
      case "specialty":
        this.rootPage = BusinessSpecialtyListPage;
        break;
      case "qr":
        this.rootPage = BusinessQrcodeScannerPage;
        break;
      case "users":
        this.rootPage = BusinessUserListPage;
        break;      
      case "profile":
        this.rootPage = BusinessDetailPage;
        break;     
      case "invoices":
        this.rootPage = BusinessInvoiceMainPage;
        break;             
      case "message":
        this.rootPage = BusinessMessagingMainPage;
        break; 
      case "products":
        this.rootPage = BusinessProductListPage;
        break;  
      case "transactions":
        this.rootPage = BusinessInvoiceMainPage;
        break;                 
      case "cashier":
        this.rootPage = BusinessProductPaymentMainPage;
        break;       
      case "categories":
        this.rootPage = BusinessProductCategoryListPage;
        break;     
      case "modifiers":
        this.rootPage = BusinessModifierGroupListPage;
        break;              
    }

    this.menuCtrl.close();
  }
}




// WEBPACK FOOTER //
// ./src/pages/business-main/business-main.ts